(function () {
  // ====== Utilidades comunes ======
  const dl = (obj) => {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(obj); }
    catch (e) { console.warn('dataLayer push error', e, obj); }
  };

  const page = window.__page || { template: 'unknown' };

  // Evento base (page_view) para todo el sitio
  dl({
    event: 'page_view',
    page_template: page.template,
    shop_domain: page.shop_domain,
    currency: page.currency
  });

  // ====== Handlers por tipo de página ======
  const handlers = {
    // Home
    index() {
      dl({ event: 'view_home' });
    },

    // Producto
    product() {
      if (!page.product) return;
      dl({
        event: 'view_item',
        ecommerce: {
          currency: page.currency,
          value: page.product.price,
          items: [{
            item_id: String(page.product.id),
            item_name: page.product.title,
            item_brand: page.product.vendor,
            item_variant: page.product.variant_title,
            price: page.product.price,
            item_category: page.product.type || undefined
          }]
        }
      });

      // (Opcional) Hook para add_to_cart por AJAX
      attachAddToCartListener();
    },

    // Colección
    collection() {
      dl({
        event: 'view_item_list',
        ecommerce: {
          item_list_id: String(page.collection?.id || ''),
          item_list_name: page.collection?.title || ''
          // Si quieres, puedes mapear items visibles leyendo DOM, pero
          // es mejor inyectar desde Liquid una lista limitada si la necesitas.
        }
      });
    },

    // Carrito
    cart() {
      if (!page.cart) return;
      dl({
        event: 'view_cart',
        ecommerce: {
          currency: page.currency,
          value: page.cart.total,
          items: page.cart.items?.map(it => ({
            item_id: String(it.id),
            item_name: it.title,
            item_variant: it.variant,
            price: it.price,
            quantity: it.quantity
          }))
        }
      });

      // Disparo begin_checkout cuando el usuario hace clic en el botón de checkout
      attachBeginCheckout('#cart > form[action*="/cart"] [name="checkout"], a[href*="/checkout"]');
    },

    // Búsqueda
    search() {
      dl({ event: 'view_search_results' });
    },

    // Página CMS genérica
    page() {
      dl({ event: 'view_cms_page' });
    },

    // Artículo de blog
    article() {
      dl({ event: 'view_article' });
    },

    // Fallback
    default() {
      // Nada extra
    }
  };

  // ====== Enrutador ======
  function run() {
    const handler = handlers[page.template] || handlers.default;
    try { handler(); } catch (e) { console.error('Handler error', page.template, e); }
  }

  // ====== Helpers de interacción ======
  function attachAddToCartListener() {
    // 1) Botones estándar con form POST
    document.addEventListener('submit', function (ev) {
      const form = ev.target;
      if (!form || !/cart\/add/.test(form.action || '')) return;
      // Intento de tomar datos básicos del producto actual
      const qty = Number((form.querySelector('[name="quantity"]')?.value || 1));
      dl({
        event: 'add_to_cart',
        ecommerce: {
          currency: page.currency,
          value: page.product?.price ? page.product.price * qty : undefined,
          items: [{
            item_id: String(page.product?.id || ''),
            item_name: page.product?.title || '',
            item_variant: page.product?.variant_title || '',
            price: page.product?.price,
            quantity: qty
          }]
        }
      });
    }, true);

    // 2) Cart AJAX (fetch a /cart/add.js). “patch” simple
    const _fetch = window.fetch;
    window.fetch = function () {
      const args = arguments;
      const url = typeof args[0] === 'string' ? args[0] : args[0].url;
      const isAdd = url && url.indexOf('/cart/add') > -1;
      return _fetch.apply(this, args).then(async (res) => {
        if (isAdd && res.ok) {
          try {
            const data = await res.clone().json();
            // data.items o data (dependiendo del tema/app)
            const line = Array.isArray(data?.items) ? data.items[0] : data;
            dl({
              event: 'add_to_cart',
              ecommerce: {
                currency: page.currency,
                value: (line?.final_line_price || line?.price || 0) / 100,
                items: [{
                  item_id: String(line?.product_id || line?.id || ''),
                  item_name: line?.title || line?.product_title || '',
                  item_variant: line?.variant_title || '',
                  price: (line?.price || 0) / 100,
                  quantity: line?.quantity || 1
                }]
              }
            });
          } catch (e) { /* silencioso */ }
        }
        return res;
      });
    };
  }

  function attachBeginCheckout(selector) {
    const clickHandler = (ev) => {
      dl({
        event: 'begin_checkout',
        ecommerce: page.cart ? {
          currency: page.currency,
          value: page.cart.total,
          items: page.cart.items?.map(it => ({
            item_id: String(it.id),
            item_name: it.title,
            item_variant: it.variant,
            price: it.price,
            quantity: it.quantity
          }))
        } : undefined
      });
    };

    // Delegación
    document.addEventListener('click', (e) => {
      const el = e.target.closest(selector);
      if (el) clickHandler(e);
    });
  }

  // ====== Boot ======
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // (Opcional) si tu tema usa navegación acelerada (instant/turbo),
  // vuelve a ejecutar cuando cambie la página:
  document.addEventListener('page:load', run);
  document.addEventListener('shopify:section:load', run);
})();
